export const getDefaultWeight = (variant, weight) => ({
    body1: weight ?? "regular",
    body2: weight ?? "regular",
    caption1: weight ?? "regular",
    caption1Underline: weight ?? "regular",
    display1: weight ?? "bold",
    display2: weight ?? "bold",
    title1: weight ?? "bold",
    title2: weight ?? "bold",
    title3: weight ?? "bold",
}[variant]);
//# sourceMappingURL=getDefaultWeight.js.map